import * as types from "./types";
import {
  getTaskAxios,
  deleteTaskAxios,
  postTaskAxios,
  putTaskAxios,
  getTaskByIDAxios,
  getTaskByLeadIDAxios,
} from "./services";

export async function getTaskListAction({ commit }) {
  commit(types.LOADING_TASK, true);
  try {
    const { data } = await getTaskAxios();
    commit(types.GET_TASK_LIST, data.result);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_TASK, false);
  }
}

export async function removeTaskAction({ commit }, payload) {
  commit(types.LOADING_TASK, true);
  try {
    await deleteTaskAxios(payload);
    commit(types.REMOVE_TASK, payload);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_TASK, false);
  }
}

export async function addTaskAction({ commit }, payload) {
  commit(types.LOADING_TASK, true);
  try {
    await postTaskAxios(payload);
    commit(types.ADD_TASK, payload);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_TASK, false);
  }
}

export async function updateTaskAction({ commit }, payload) {
  commit(types.LOADING_TASK, true);
  try {
    await putTaskAxios(payload);
    commit(types.UPDATE_TASK, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_TASK, false);
  }
}

export async function getTaskByIdAction({ commit }, payload) {
  commit(types.LOADING_TASK, true);
  try {
    await getTaskByIDAxios(payload);
    commit(types.GET_TASK_BY_ID, payload);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_TASK, false);
  }
}

export async function getTaskByLeadIdAction({ commit }, payload) {
  commit(types.LOADING_TASK, true);
  try {
    const { data } = await getTaskByLeadIDAxios(payload);
    commit(types.GET_TASK_BY_LEADID, data.result);
    console.log("tasklisting", data.result);
    //return data.result;
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_TASK, false);
  }
}
